import { useEffect } from 'react';
export const useShowOptions = ({ setOptionsAreOpen, focused }) => {
    useEffect(() => {
        setOptionsAreOpen(focused);
    }, [focused, setOptionsAreOpen]);
};
